



































































import { Component, Vue, Prop } from "vue-property-decorator";
import { ATMPair } from "@foxone/api/src/models/market";
import { TradeSide } from "@foxone/api/src/models/market";

@Component
class StrategyForm extends Vue {
  @Prop() strategy;

  @Prop() pair!: ATMPair;

  advanced = false;

  advancedType = "";

  get meta() {
    const { strategy } = this;

    if (!strategy) {
      return {};
    }

    const options = strategy.options.map(option => {
      const unit =
        typeof option.unit === "function" ? option.unit(this) : option.unit;
      const min =
        typeof option.min === "function" ? option.min(this) : option.min;
      const max =
        typeof option.max === "function" ? option.max(this) : option.max;
      const hint =
        typeof option.hint === "function"
          ? option.hint(this, `${min || "-"} ${unit}`, `${max || "-"} ${unit}`)
          : option.hint;
      const rules =
        typeof option.rules === "function"
          ? option.rules(this, `${min || "-"} ${unit}`, `${max || "-"} ${unit}`)
          : "";
      return {
        ...option,
        unit,
        hint,
        rules
      };
    });

    const { symbol = "", price_precision = 0 } = this.pair || {};
    const { presetOptions, priceChangeLabel, priceLimitLabel } = this.strategy;
    const presetOption = presetOptions.find(
      option => option.value === this.advancedType
    );
    const { priceLimit: limit = 1, priceChange: change = 0 } =
      presetOption || {};
    const { price_buy, price_sell } = this.pair || {};
    const price = this.strategy.side === TradeSide.ASK ? price_sell : price_buy;
    const priceLimit = this.$common.utils.number.toPrecision(
      limit * (+price || 0),
      price_precision
    );
    const priceChange = change * 100 + "%";
    const unit =
      (this.pair && this.pair.quote && this.pair.quote.symbol) || "-";

    return {
      unit,
      options,
      symbol,
      presetOption,
      presetOptions,
      priceLimitLabel,
      priceChangeLabel,
      priceLimit,
      priceChange
    };
  }

  submit() {
    if (!this.pair) {
      this.$common.utils.helper.toast(this, {
        message: this.$t("common.pair.unsupport") as string,
        color: "error"
      });
      return;
    }
    if (!this.advanced) {
      const values = {
        price_change: this.meta.presetOption.priceChange + "",
        price_limit: this.meta.priceLimit,
        side: this.strategy.side
      };
      return values;
    } else {
      const form = this.$refs.form as any;
      const valid = form.validate();
      if (valid) {
        const values = {};
        this.meta.options.forEach(option => {
          if (option.transfrom) {
            values[option.field] = option.transfrom(option.value);
          } else {
            values[option.field] = option.value;
          }
        });
        return values;
      }
    }
    return;
  }
}
export default StrategyForm;
